<template>
  <b-row v-if="pipelineResponse.show">
    <b-col>
      <template v-if="pipelineResponse.succeeded.length > 0">
        <div id="sta-pipe-success-combined" v-if="combined" class="alert alert-success fade show d-flex" role="alert">
          <span id="sta-combined-total-success" v-if="pipelineResponse.failed.length === 0">
            Update was successful.
          </span>
          <span id="sta-combined-partial-success" v-else>
            Update was partially successful. See errors below.
          </span>
          <button type="button" class="close ml-auto" aria-label="Close" v-on:click="clearSuccess">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div :id="`sta-pipe-success-${forType}-${forRole}`" v-else
             class="alert alert-success fade show d-flex" role="alert">
          Update was successful for {{pipelineResponse.succeeded.length}} {{forType}} {{forRole}}(s)
          <button type="button" class="close ml-auto" aria-label="Close" v-on:click="clearSuccess">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>
      <template v-if="pipelineResponse.failed.length > 0">
        <div id="sta-pipe-fail" class="alert alert-danger alert-dismissible fade show d-flex" role="alert">
          <div>Update failed for {{forRole}}(s):
            <div v-for="(failed, index) in pipelineResponse.failed" :key="index">
              <div>
                <span>{{failed.id}} - {{failed.reason}}</span>
              </div>
            </div>
          </div>
          <button type="button" class="close ml-auto" data-dismiss="alert" aria-label="Close" v-on:click="clearFailed">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'PiplelineStatusAlert',
  props: {
    pipelineResponseName: {
      type: String,
      required: true,
    },
    forType: {
      type: String,
      required: true,
    },
    forRole: {
      type: String,
      required: true,
    },
    combined: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pipelineResponse() {
      return this.$store.state[this.pipelineResponseName];
    },
  },
  methods: {
    clearSuccess() {
      this.$store.commit('setPipelineSuccess', this.pipelineResponseName);
    },
    clearFailed() {
      this.$store.commit('setPipelineFailed', this.pipelineResponseName);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PipelineStatusAlert.vue